export const imageStringToBase64 = (image: string) => {
  return image.replace(/data:.*base64,/, '');
};
